import { AppsPaths, getAppPort } from './appPort'

export const defineHost = (defaultURL: string, baseName: AppsPaths) => {
  const httpIsEnabled = import.meta.env.VITE_USE_HTTP

  if (!httpIsEnabled) return defaultURL

  const port = getAppPort(baseName)
  const newUrl = defaultURL.replace('https://', 'http://').replace('spark.local', `localhost:${port}`)
  return newUrl
}
